import axios from "axios";
import { API_URL } from "../config";

const api = axios.create({
  baseURL: API_URL ? `${API_URL}/api` : "http://localhost:5000/api",
});

export const getAssetUrl = (assetPath) => {
  if (!API_URL || API_URL === "/api") return assetPath;

  const backendBaseUrl = API_URL.replace(/\/api\/?$/, "");
  return `${backendBaseUrl}${assetPath}`;
};

export default api;
